import { useMemo } from 'react';

import { usePetitionUpdatePageData } from 'src/app/pages/petitionUpdate/details/pageContext';
import type { RoundShareIconButtonConfig } from 'src/app/shared/components/share';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { mapButtonConfigs } from './mapButtonConfigs';
import type { Channel } from './types';
import { useShareOptions } from './useShareOptions';

type Result = ModelHookResult<{
	buttonConfigs: readonly RoundShareIconButtonConfig[];
}>;

export function useShareLinks({ disableShortLinks }: { disableShortLinks: boolean }): Result {
	const options = useShareOptions({ disableShortLinks });
	const {
		data: {
			featureConfigs: { globalShareButtonConfig: channels },
		},
	} = usePetitionUpdatePageData();

	const availableShareActions = useAvailableShareActions(channels, options);
	return {
		data: {
			buttonConfigs: useMemo(() => mapButtonConfigs(availableShareActions), [availableShareActions]),
		},
	};
}

export type { Channel };
